import apiMaintenanceSchedule from 'services/inventory/maintenance-schedule'

export const handleGetMaintenanceSchedule = async (id: string) => {
  let res = await apiMaintenanceSchedule.get(id)

  return res?.data?.data
}

export const handleSave = async (values: any) => {
  let res = await apiMaintenanceSchedule.update(values)

  return res?.data?.success
}
